import React from "react";
import PropTypes from "prop-types"

import Toolbar from "@mui/material/Toolbar";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


import {WrapTopbar, Title, Page, Content, WrapActions} from "./theme";


export default class AdminPage extends React.Component {

    renderBackLink = () => {
        const {backLink} = this.props;
        if (backLink) {
            if (typeof backLink === "string") {
                return (
                    <IconButton onClick={() => {
                        if (this.props.history.length > 0) {
                            this.props.history.goBack()
                        } else {
                            this.props.history.push(backLink)
                        }

                    }}>
                        <ArrowBackIcon/>
                    </IconButton>
                );
            }
            if (typeof backLink === "function") {
                return backLink();
            }
        }
        return null;
    }


    render() {
        const {title, actions, padding} = this.props;
        const actionsCmp = actions ? actions.map((act, i) => {
                return <WrapActions key={`a${i}`}>{act}</WrapActions>;
            }) : [];
        return (

            <Page>
                <WrapTopbar>
                    <div className="admin-topbar">
                        <Toolbar> {
                            this
                                .renderBackLink()
                        }
                            <Title>
                                {title}
                            </Title>
                            {
                                actionsCmp
                            }
                        </Toolbar>
                    </div>

                </WrapTopbar>
                <Content padding={padding}>{this.props.children}</Content>
            </Page>
        )
            ;
    }
}


AdminPage.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    actions: PropTypes.array,
    padding: PropTypes.string,
    backLink: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
